import { format, parse } from 'date-fns';

export function parseDateToISO(date: string | null | undefined): string | null {
  if (!date) return null;
  // `new Date()` is date-fns' `referenceDate`: it fills the fields the pattern doesn't cover
  // (here, only the time). Since `dd/MM/yyyy` covers the whole date, it never affects the output.
  return format(parse(date, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
}

/** A Date `seconds` from now; negative values land in the past. */
export const inSeconds = (seconds: number): Date => new Date(Date.now() + seconds * 1000);
